import React, { useEffect, useState } from 'react'
import './SchoolPartnership.css'
import icon from '../../assetsS/images/fa-solid_school.png'

const Gallery = () => {
  useEffect(() => {})

  return (
    <div className="school-intro">
      <div className="container">

        {/* Icon */}
        <div className="school-intro__icon-wrap">
          <img src={icon} alt="School" className="school-intro__icon" />
        </div>

        {/* Heading */}
        <h2 className="school-intro__headline">
          <span className="school-intro__accent">School</span> Admin Login
        </h2>

        {/* Divider */}
        <div className="school-intro__divider" />

        {/* Body */}
        <p className="school-intro__body">
          We partner with schools and help them provide quality, disciplined
          testing practice and train their students in the aspect of speed
          and accuracy in facing competitive exam we align with the school
          time schedule and curriculum, enable them to evaluate and train
          their students with the help of our software. It helps find each
          students strength, weakness through capability analysis reports by
          advanced Al system, where the teachers need not do capability
          analysis manually.
        </p>

      </div>
    </div>
  )
}

export default Gallery